import { useState } from "react";
import { Modal, Select, Input, Tag } from "antd";
import { toast } from "react-toastify";
import trans from "../../../utils";
import { useGetAllTechnicianFromUsersQuery } from "../../../Redux/service/Technician/Technician";

export default function BulkAssignModal({ open, onClose, selectedIds, onContinue }) {
  const [technicianUserId, setTechnicianUserId] = useState(null);
  const [notes, setNotes] = useState("");

  const { data: techniciansResp, isFetching: loadingTechnicians } =
    useGetAllTechnicianFromUsersQuery({ page: 1, pageSize: 10000 }, { skip: !open });

  const technicianOptions = (techniciansResp?.fieldWorkers || []).map((tech) => ({
    label: tech.disabled ? `${tech.name} (${trans("Inactive")})` : tech.name,
    value: tech.id,
    disabled: !!tech.disabled,
  }));

  const handleClose = () => {
    setTechnicianUserId(null);
    setNotes("");
    onClose();
  };

  const handleNext = () => {
    if (!technicianUserId) {
      toast.error(trans("Please select a technician"), { autoClose: 2000 });
      return;
    }
    const technician = (techniciansResp?.fieldWorkers || []).find((t) => t.id === technicianUserId);
    onContinue({ technicianUserId, technicianName: technician?.name || "", notes });
    setTechnicianUserId(null);
    setNotes("");
  };

  return (
    <Modal
      title={trans("Assign to Technician")}
      open={open}
      onCancel={handleClose}
      onOk={handleNext}
      okText={trans("Next")}
      cancelText={trans("Cancel")}
    >
      <div className="mb-3">
        <Tag color="blue">
          {selectedIds.length} {trans("Requests Selected")}
        </Tag>
      </div>
      <div className="mb-3">
        <label className="d-block mb-1">{trans("Technician")}</label>
        <Select
          showSearch
          allowClear
          optionFilterProp="label"
          style={{ width: "100%" }}
          placeholder={trans("Select a technician")}
          loading={loadingTechnicians}
          options={technicianOptions}
          value={technicianUserId}
          onChange={setTechnicianUserId}
        />
      </div>
      <div>
        <label className="d-block mb-1">{trans("Notes")}</label>
        <Input.TextArea
          rows={3}
          placeholder={trans("Optional notes")}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>
    </Modal>
  );
}
